import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { Location } from '../../../common/react/Location';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { ProjectDefinition } from '../../../ts/models/ContentDefinitions';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface RecommendationsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
}

export interface RecommendationsSpaceOwnProps extends ReactDirectiveProps {
  readonly telemetry: Telemetry;
}

export type RecommendationsSpaceProps = RecommendationsSpaceStateProps & RecommendationsSpaceOwnProps;

export class RecommendationsSpace extends React.PureComponent<RecommendationsSpaceProps> {
  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={ SpaceContainerStyles.MastheadArea }>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.vizRecommendationsTitle()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['thumbnail']}
            telemetry={this.props.telemetry}
            emptyStateProps={this.emptyStateProps()}
            showAsRecommendation={true}
            toolbarProps= {{
              supportFilterPanel: false,
              // TODO TFS 890269 add filter by explanation UI in tool bar
              toolbarVisibility: 'hidden'
            }}
          />
        </div>
      </div>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      // TODO TFS 895845 update icon
      iconUrl: imgPath('spaces_empty_recent.svg'),
      primaryMessage: Messages.vizRecommendationsEmptyStatePrimary(),
      secondaryMessage: Messages.vizRecommendationsEmptyStateSecondary()
    };
  }
}
